import React, { useContext } from 'react';
import RecorderDrawerContext from '../../Context';
import { MultipleProfileDetails } from './MultipleProfileDetails';
import { SingleProfileDetails } from './SingleProfileDetails';

export function ProfileDetailsPanel() {
  const { profiles } = useContext(RecorderDrawerContext);

  const hasMultipleProfiles = profiles != undefined && profiles?.length > 1;
  return (
    <div className='flex flex-col w-full gap-y-6'>
      <div className='flex flex-row gap-x-4 items-center'>
        <i className='icon icon-record !v2-bg-neutral-900' />
        <span className='text-lg lg:text-[21px] font-bold'>
          Record a video message for
        </span>
      </div>
      <div className='flex flex-col lg:justify-between w-full gap-y-4'>
        {hasMultipleProfiles ? (
          <MultipleProfileDetails />
        ) : (
          <SingleProfileDetails />
        )}
      </div>
    </div>
  );
}
